var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#387"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.287 16.714a3.64 3.64 0 00-5.147 0l-2.574 2.573a3.64 3.64 0 105.148 5.148L18 23.148",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.715 19.287a3.64 3.64 0 005.146 0l2.575-2.573a3.64 3.64 0 10-5.148-5.148l-1.287 1.287",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDM2IDM2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiMzMzg4NzciLz4KICAgIDxwYXRoIGQ9Ik0xOS4yODY5IDE2LjcxNEMxOC42MDQzIDE2LjAzMTcgMTcuNjc4NyAxNS42NDg0IDE2LjcxMzYgMTUuNjQ4NEMxNS43NDg1IDE1LjY0ODQgMTQuODIyOCAxNi4wMzE3IDE0LjE0MDIgMTYuNzE0TDExLjU2NjEgMTkuMjg3NEMxMC44ODM1IDE5Ljk3IDEwLjUgMjAuODk1OCAxMC41IDIxLjg2MTFDMTAuNSAyMi44MjY1IDEwLjg4MzUgMjMuNzUyMyAxMS41NjYxIDI0LjQzNDlDMTIuMjQ4NyAyNS4xMTc1IDEzLjE3NDUgMjUuNTAxIDE0LjEzOTggMjUuNTAxQzE1LjEwNTIgMjUuNTAxIDE2LjAzMSAyNS4xMTc1IDE2LjcxMzYgMjQuNDM0OUwxOC4wMDAyIDIzLjE0ODIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMTYuNzE0OCAxOS4yODY5QzE3LjM5NzQgMTkuOTY5MiAxOC4zMjMxIDIwLjM1MjUgMTkuMjg4MiAyMC4zNTI1QzIwLjI1MzMgMjAuMzUyNSAyMS4xNzg5IDE5Ljk2OTIgMjEuODYxNSAxOS4yODY5TDI0LjQzNTcgMTYuNzEzNkMyNS4xMTgzIDE2LjAzMSAyNS41MDE4IDE1LjEwNTIgMjUuNTAxOCAxNC4xMzk4QzI1LjUwMTggMTMuMTc0NSAyNS4xMTgzIDEyLjI0ODcgMjQuNDM1NyAxMS41NjYxQzIzLjc1MzEgMTAuODgzNSAyMi44MjczIDEwLjUgMjEuODYxOSAxMC41QzIwLjg5NjYgMTAuNSAxOS45NzA4IDEwLjg4MzUgMTkuMjg4MiAxMS41NjYxTDE4LjAwMTUgMTIuODUyNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgCopyin as ReactComponent };